export const brand = {
  sky: "#11A5E5",
  blue: "#0875AD",
  navy: "#0B3552",
  navyDeep: "#082C45",
  orange: "#DE7A2B",
  success: "#23B88B",
  surface: "#F5F8FA",
  text: "#203149",
  muted: "#6F7F92",
  line: "#E7EDF2",
};

export const brandGradient = `linear-gradient(135deg, ${brand.sky} 0%, ${brand.blue} 48%, ${brand.navy} 100%)`;
